// extracted by mini-css-extract-plugin
module.exports = {"native":"_14325","vant":"_18547"};